module.exports = __webpack_public_path__ + "static/media/question_mark_red.fc96f428.svg";